// --------------------------------------------------------------
// Created On: 2026-05-07
// Author: Zachary Thomas
//
// Last Modified: 2026-05-08
// Modified By: KC Willard
//
// Copyright 2026 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

// Store information related to documents that users should have access to.
export const PRIVACY_POLICY = "/legal/Privacy_Policy.pdf";
export const EULA = "/legal/EULA.pdf";
export const COPILOT_INSTALLATION_GUIDE = {
  resourceId: 0,
  name: "Co-Pilot Installation Guide (Standard Diesel Engine Controllers)",
  endpoint: "manuals/Manual_CoPilot_Installation_Guide.pdf",
};
export const PMG_MANUAL = {
  resourceId: 0,
  name: "Co-Pilot PMG Data Sheet",
  endpoint: "manuals/DS_Co-Pilot PANEL MOUNTED GATEWAY 1.pdf",
};
export const VIBRATION_SENSOR_MANUAL = {
  resourceId: 0,
  name: "Co-Pilot External Vibration Sensor Data Sheet",
  endpoint: "manuals/BR Co-Pilot External Vibration Sensor - 2024.pdf",
};
export const EVS_MANUAL = {
  resourceId: 0,
  name: "Co-Pilot External Vibration Sensor user-manual",
  endpoint: "manuals/Co-Pilot External Vibration Sensor user-manual.pdf",
};
export const PULSE_MANUAL = {
  resourceId: 0,
  name: "Pulse Data Sheet",
  endpoint: "manuals/Pulse_Data_Sheet.pdf",
};
export const SEEKER_MANUAL = {
  resourceId: 0,
  name: "Seeker Pamphlet",
  endpoint: "manuals/RPM2_Seeker_pamphlet.pdf",
};
export const DEVICE_CONTROLLER_MANUAL_MAP: ManualDeviceControllerMap = {
  COPILOT: {
    AID_VFD: {
      resourceId: 0,
      name: "AID Configuration and Install Notes",
      endpoint: "manuals/AID Configuration and Install Notes.pdf",
    },
    CP1000: {
      resourceId: 0,
      name: "2025 CP1000 - Installation Guide for Co-Pilot",
      endpoint: "manuals/2025 CP1000 - Installation Guide for Co-Pilot.pdf",
    },
    "CP750-T3": {
      resourceId: 0,
      name: "2025 CP750 - Installation Guide for Co-Pilot",
      endpoint: "manuals/2025 CP750-E - Installation Guide for Co-Pilot.pdf",
    },
    CP750: {
      resourceId: 0,
      name: "2025 CP750 - Installation Guide for Co-Pilot",
      endpoint: "manuals/2025 CP750-E - Installation Guide for Co-Pilot.pdf",
    },
    MPC10: {
      resourceId: 0,
      name: "Installation Guide for Co-Pilot_Murphy Controller",
      endpoint: "manuals/Installation Guide for Co-Pilot_Murphy Controller.pdf",
    },
    CSERIES: {
      resourceId: 0,
      name: "Installation Guide for Co-Pilot_Controls Inc",
      endpoint: "manuals/Installation Guide for Co-Pilot_Controls Inc.pdf",
    },
    "CONTROLSINC-LEGACY": {
      resourceId: 0,
      name: "OLD_Wiring Instructions- Co-Pilot to Controls Inc C Series Panel",
      endpoint: "manuals/OLD_Wiring Instructions- Co-Pilot to Controls Inc C Series Panel.pdf",
    },
    "CONTROLSINC-MAPD": {
      resourceId: 0,
      name: "Installation Guide for Co-Pilot_Controls Inc",
      endpoint: "manuals/Installation Guide for Co-Pilot_Controls Inc.pdf",
    },
  },
  COPILOTPMG: {
    CP1000: {
      resourceId: 0,
      name: "2025 CP1000 - Installation Guide for Co-Pilot",
      endpoint: "manuals/2025 CP1000 - Installation Guide for Co-Pilot.pdf",
    },
    CP750: {
      resourceId: 0,
      name: "2025 CP750 - Installation Guide for Co-Pilot",
      endpoint: "manuals/2025 CP750 - Installation Guide for Co-Pilot.pdf",
    },
  },
};

interface ManualDeviceControllerMap {
  [key: string]: ManualControllerMap;
}

interface ManualControllerMap {
  [key: string]: Resource;
}

interface Resource {
  resourceId: number;
  name: string;
  endpoint: string;
}
